import { validate as uuidValidate, version as uuidVersion } from 'uuid';

/**
 * Checks UUID syntax and RFC version through the maintained UUID library.
 * Keeping parsing here avoids duplicating RFC bit-layout rules in consumers.
 *
 * @param {unknown} value - Candidate UUID value.
 * @returns {boolean} Whether the value is a valid UUIDv7.
 */
export const isUuidV7 = (value) =>
  typeof value === 'string' && uuidValidate(value) && uuidVersion(value) === 7;
